import { saveState } from '@helpers/localStorage';
import { getListValues } from '../sponsoredProducts/pushDataToTracking';
import type { FormattedTrackingParams } from './types';

export const storeFormattedTrackingParams = (event: string, {
    currentPage, productId, productIndex, productsGroup, productsPerPage, productsPerRow, totalProducts, variantId,
}: FormattedTrackingParams) => {
    const formattedListParams = getListValues({
        currentPage,
        productsGroup,
        productIndex,
        productsPerPage,
        productsPerRow,
        totalProducts,
    });

    const data = {
        list: formattedListParams,
        product_id: productId,
        variant_id: variantId,
    };

    saveState(event, data);
};
